import { useEffect } from 'react'
import {
  Button,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap'

import FormSchemaValidations from './schema-validations'
import FormBase from './form-base'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { setOpenModal, editUserAction } from '../store'
import { useDispatch, useSelector } from 'react-redux'
import toast from 'react-hot-toast'
import { updateProduct } from '../thunks'

const Edit = () => {
  const dispatch = useDispatch()
  const { modal } = useSelector((state) => state.productServiceMaster)

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      type_of_entity: '',
      nit: '',
      nrc: '',
      society: '',
      type_of_establishment: '',
      address: '',
      phone: '',
      economic_activity: '',
      main_admin_name: '',
      main_admin_email: '',
      reset_main_admin_password: '',
      service_to_acquire_digital_signature: [],
      service_to_acquire_digital_invoice: [],
      isActive: false,
    },
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(FormSchemaValidations),
  })

  const inputs = {
    typeEntity: { disabled: true },
    DUI: { disabled: true },
    NIT: { disabled: true },
  }

  const onSubmit = async (data) => {
    dispatch(
      updateProduct({
        ...data,
        quantity: 100, // solo aplica para facturas
        prodTypeId: data.prodType?.id,
        unitOfMeasureId: data.unitOfMeasure.id,
        typeOfSale: 'retail', // solo aplica para facturas
        discount: 1.0, // solo aplica para facturas
        accept: true, // solo aplica para facturas
      })
    )
      .unwrap() // Para manejar la respuesta de la acción
      .then((result) => {
        // Acción después de que la actualización se complete
        dispatch(editUserAction(result))
        handleClose()
        toast.success('Registro editado con éxito')
      })
      .catch((error) => {
        console.error('Error updating user:', error)
      })
  }
  const handleClose = () => {
    dispatch(setOpenModal({ type: 'edit', open: false }))
  }

  useEffect(() => {
    if (modal.edit.open && modal.edit.data) {
      // Set the form values with the data from the modal
      for (const [key, value] of Object.entries(modal.edit.data)) {
        setValue(key, value)
      }
    }
  }, [modal.edit.open, modal.edit.data, setValue])
  return (
    <Modal
      isOpen={modal.edit.open}
      toggle={handleClose}
      className="modal-dialog-centered modal-lg"
    >
      <ModalHeader
        className="bg-transparent"
        toggle={handleClose}
      ></ModalHeader>

      <FormProvider
        {...{
          handleSubmit,
          control,
          reset,
          setValue,
          formState: { errors },
        }}
      >
        <Form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <h1>Editar</h1>
            </div>
            <FormBase
              input={inputs}
              initialTypeEntity={modal.edit.data?.typeEntity}
            />
            <div>
              <p>Campos obligatorios (*)</p>
            </div>
          </ModalBody>

          <ModalFooter className={'d-flex justify-content-center'}>
            <Button
              color="primary"
              type="submit"
            >
              Guardar
            </Button>
            <Button
              type="reset"
              color="secondary"
              outline
              onClick={handleClose}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </FormProvider>
    </Modal>
  )
}

export default Edit
